'use client';

import { Auth0 } from '@modules/auth/components/Auth0/Auth0';
import { LoginWithRedirectOptions, PromptOptions } from '@modules/auth/providers/CommonAuthProvider/CommonAuthProvider';

import React, { useMemo } from 'react';
import { IdentityProvider } from 'shared/src/util';

/**
 * This page is pretty much unused with the exception of some Marketing related stuff.
 */
export const LoginRedirectPage: React.FC = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const connection = searchParams.get('connection') ?? '';
  const redirectUri = searchParams.get('redirect_uri') ?? '';
  const prompt = searchParams.get('prompt') ?? '';
  const organization = searchParams.get('organization') ?? '';
  const provider = process.env.AUTH_CLIENT_PROVIDER as string;
  let returnTo = searchParams.get('returnTo');

  const authorizationParams: LoginWithRedirectOptions = useMemo(() => ({
    connection,
    redirect_uri: redirectUri,
    prompt: prompt as PromptOptions,
  }), [connection, redirectUri, prompt]);

  if (!returnTo) {
    if (provider === IdentityProvider.AUTH0) {
      returnTo = `/organizations/${organization || connection}`;
    } else if (organization) {
      // if provider is okta, we are in a gov environment and
      // cannot assume that the connection is the org id.
      returnTo = `/organizations/${organization}`;
    }
  }

  return (
    <Auth0 authorizationParams={authorizationParams} appState={returnTo && { returnTo }} />
  );
};
